import * as Yup from 'yup';
import { validatePasswordErrors } from './validate';

// O trim espelha o back, que apara a senha no create-password e no login.
export const passwordPolicySchema = Yup.string()
  .trim()
  .required('A Senha é obrigatória')
  .test(
    'password-policy',
    'A senha não atende aos requisitos.',
    (value) => !value || validatePasswordErrors(value).length === 0
  );
